import React, { useState, useRef, useEffect } from 'react';

const AudioPlayer = ({ playlist }) => {
  const [currentTrackIndex, setCurrentTrackIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isCoverImageLoading, setIsCoverImageLoading] = useState(false);
  
  const audioRef = useRef(new Audio());
  const baseUrl = process.env.REACT_APP_API_URL;


  useEffect(() => {
    const audio = audioRef.current;
    
    // Set up audio event listeners
    audio.addEventListener('timeupdate', updateProgress);
    audio.addEventListener('loadedmetadata', () => setDuration(audio.duration));
    audio.addEventListener('ended', handleTrackEnd);

    // Load first track
    console.log(currentTrackIndex)
    loadTrack(currentTrackIndex);

    return () => {
      // Cleanup event listeners
      audio.removeEventListener('timeupdate', updateProgress);
      audio.removeEventListener('loadedmetadata', () => setDuration(audio.duration));
      audio.removeEventListener('ended', handleTrackEnd);
      audio.pause();
    };
  }, [currentTrackIndex, isPlaying, playlist]);

  const loadTrack = (index) => {
    const audio = audioRef.current;
    
    // Remove any existing sources
    audio.src = baseUrl + `/` + playlist[index].audioMedia.url;
    
    // Reset the audio element
    audio.load();
    
    setCurrentTrackIndex(index);
    setIsCoverImageLoading(true);
  
    // Always play if isPlaying is true
    if (isPlaying) {
      audio.play().catch(error => {
        console.error('Error playing audio:', error);
      });
    }
  };

  const updateProgress = () => {
    setCurrentTime(audioRef.current.currentTime);
  };

  const onCoverImageLoad = () => {
    setIsCoverImageLoading(false);
  };

  const handleTrackEnd = () => {
    playNext();
  };

  const playPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const stop = () => {
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
    setIsPlaying(false);
    setCurrentTime(0);
  };

  const playNext = () => {
    const nextIndex = (currentTrackIndex + 1) % playlist.length;
    loadTrack(nextIndex);
  };

  const playPrevious = () => {
    const prevIndex = (currentTrackIndex - 1 + playlist.length) % playlist.length;
    loadTrack(prevIndex);
  };

  const selectTrack = (index) => {
    loadTrack(index);
    setIsPlaying(true);
  };

  const handleSeek = (e) => {
    const time = e.target.value;
    audioRef.current.currentTime = time;
    setCurrentTime(time);
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  };

  return (



    <div className="audio-player">
      {/* Current Track Info */}
      <div className="audio-player__cover">
        {playlist[currentTrackIndex].cover && playlist[currentTrackIndex].cover.formats?.large?.url ? (
          <img
            src={`${baseUrl}${playlist[currentTrackIndex].cover.formats.large.url}`}
            alt="Album Art"
            className={`audio-player__cover-image ${
                isCoverImageLoading ? 'cover-image-fade-in' : ''
              } 
              ${
                isPlaying ? 'cover-image-play' : ''
              }
              `}
              onLoad={onCoverImageLoad}
          />
        ) : null}
        <h2 className="">{playlist[currentTrackIndex].title}</h2>
        <p className="">{playlist[currentTrackIndex].artist}</p>
      </div>

    <div className='audio-player__content'>
    


      {/* Playlist */}
        <div className="audio-player__playlist">
          {playlist.map((track, index) => (
            <div
              key={index}
              onClick={() => selectTrack(index)}
              className={`flex items-center p-2 hover:bg-gray-100 cursor-pointer rounded ${
                currentTrackIndex === index ? 'bg-gray-100' : ''
              }`}
            >
              
              <div className='audio-player__playlist-entry'>

              {isPlaying && currentTrackIndex === index ? (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="m5 3l14 9l-14 9V3z"/></svg>
                ): (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></g></svg>
              )}


                <div className="audio-player__track-playlist-title">{track.title}</div>
              </div>
            </div>
          ))}
        </div>

  {/* Progress Bar */}
  <div className="audi-player__track">
        <input
          type="range"
          min="0"
          max={duration || 0}
          value={currentTime}
          onChange={handleSeek}
          className=""
        />
        <div className="audio-player__time">
          <span>{formatTime(currentTime)}</span>
          <span>{formatTime(duration)}</span>
        </div>
      </div>

      {/* Controls */}
      <div className="audio-player__controls">
        <button
          onClick={playPrevious}
          className=""
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="m11 17l-5-5l5-5m7 10l-5-5l5-5"/></svg>
        </button>
        <button
          onClick={playPause}
          className=""
        >
          {isPlaying ? 
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M6 4h4v16H6zm8 0h4v16h-4z"/></svg> 
          :
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="m5 3l14 9l-14 9V3z"/></svg>}
        </button>
        <button
          onClick={stop}
          className=""
        >
         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect width="18" height="18" x="3" y="3" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" rx="2" ry="2"/></svg>
        </button>
        <button
          onClick={playNext}
          className=""
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="m13 17l5-5l-5-5M6 17l5-5l-5-5"/></svg>
        </button>
      </div>



        </div> 
         {/* END PLAYLIST CONTENT */}
    </div>
  );
};

export default AudioPlayer;